import * as types from '../../action-types';
import { getSingleOffer as initialState } from "../../initialState";

const getSingleOffer  = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_OFFER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_OFFER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_OFFER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_OFFER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleOffer ;
